// utils/localStorage.js
import CryptoJS from 'crypto-js';

const ENCRYPTION_KEY = '4bcbe98c05f58cb9d7cb0e14715d8dc382e405f0bb5f74463aae0fd0e547ce8b'; //AguaEnterprise!@#11551

export const isAdmin = () => {
  try {
    const getResponse = getEncryptedLocalStorageItem('user')
    return getResponse && getResponse?.email === "admin@aguaws.com";
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
    return false;
  }
};


// Function to set an encrypted item in local storage
export const setLoginEncryptedLocalStorage = (data) => {
  try {
    const encryptedUser = CryptoJS.AES.encrypt(JSON.stringify(data.data), ENCRYPTION_KEY).toString();
    localStorage.setItem(`enterprise-user`, encryptedUser);

    const encryptedToken = CryptoJS.AES.encrypt(JSON.stringify(data.token), ENCRYPTION_KEY).toString();
    localStorage.setItem(`enterprise-token`, encryptedToken);
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to set an encrypted item in local storage
export const removeLoginEncryptedLocalStorage = () => {
  try {
    localStorage.removeItem('enterprise-user');
    localStorage.removeItem('enterprise-token');
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to set an encrypted item in local storage
export const setEncryptedLocalStorageItem = (key, value) => {
  try {
    const encryptedValue = CryptoJS.AES.encrypt(JSON.stringify(value), ENCRYPTION_KEY).toString();
    localStorage.setItem(`enterprise-${key}`, encryptedValue);
  } catch (error) {
    console.error('Error setting encrypted local storage:', error);
  }
};

// Function to get an encrypted item from local storage
export const getEncryptedLocalStorageItem = (key) => {
  try {
    const encryptedValue = localStorage.getItem(`enterprise-${key}`);
    if (encryptedValue) {
      const bytes = CryptoJS.AES.decrypt(encryptedValue, ENCRYPTION_KEY);
      const decryptedValue = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
      return decryptedValue;
    }
    return null;
  } catch (error) {
    console.error('Error getting encrypted local storage:', error);
    return null;
  }
};

// Function to remove an encrypted item from local storage
export const removeEncryptedLocalStorageItem = (key) => {
  try {
    localStorage.removeItem(`enterprise-${key}`);
  } catch (error) {
    console.error('Error removing encrypted local storage:', error);
  }
};

// Function to remove an encrypted item from local storage
export const checkEncryptedLocalStorageItem = () => {
  try {
    return localStorage.getItem('enterprise-token') !== null;
  } catch (error) {
    console.error('Error removing encrypted local storage:', error);
    return false;
  }
};